// Form-state helpers for the vendor cost model (pricingModel / costPerLead / recurringBudget).

/** Cost fields for a brand-new vendor. */
export function costDefaults() {
  return {
    pricingModel: 'flat_per_lead',
    costPerLead: '',
    recurringBudget: { amount: '', interval: 'weekly' },
  };
}

/**
 * Derive cost form state from a stored vendor. Legacy vendors with only
 * `defaultCostPerLead` surface it as the flat per-lead cost.
 * @param {object} v - Vendor document.
 */
export function hydrateCost(v) {
  const flat = v?.costPerLead > 0 ? v.costPerLead : v?.defaultCostPerLead;
  return {
    pricingModel: v?.pricingModel || 'flat_per_lead',
    costPerLead: flat ? String(flat) : '',
    recurringBudget: {
      amount: v?.recurringBudget?.amount ? String(v.recurringBudget.amount) : '',
      interval: v?.recurringBudget?.interval || 'weekly',
    },
  };
}

/**
 * Wire fields for save. `defaultCostPerLead` mirrors the flat cost so legacy
 * readers (customFields.costPerLead, marketplace) stay consistent.
 * @param {object} form
 */
export function buildCostFields(form) {
  const model = form.pricingModel || 'flat_per_lead';
  const flat = model === 'flat_per_lead' ? parseFloat(form.costPerLead) || 0 : 0;
  return {
    pricingModel: model,
    costPerLead: flat,
    defaultCostPerLead: flat,
    recurringBudget: {
      amount: model === 'recurring_budget' ? parseFloat(form.recurringBudget?.amount) || 0 : 0,
      interval: form.recurringBudget?.interval === 'monthly' ? 'monthly' : 'weekly',
    },
  };
}
